import { IMember, MEMBER_SOURCE_LINGSHOUTONG } from '../../../../../model/types/member'

type MemberStatisticKey =
    | 'accumulated_recharge'
    | 'accumulated_consume'
    | 'accumulated_consume_count'
    | 'total_recharge_amount'
    | 'total_consume_amount'
    | 'total_consume_times'

const hasDisplayValue = (value: IMember[MemberStatisticKey]) => value !== undefined && value !== null && value !== ''

const toAmountNumber = (value: string | number | undefined) => Number(value || 0)

const formatAmountString = (value: number) => {
    return value.toFixed(2)
}

export const getMemberStatisticValue = (
    member: Partial<IMember>,
    accumulatedKey: MemberStatisticKey,
    totalKey: MemberStatisticKey,
) => {
    const accumulatedValue = member[accumulatedKey]
    if (hasDisplayValue(accumulatedValue)) {
        return accumulatedKey === 'accumulated_consume_count' ? accumulatedValue : Number(accumulatedValue).toFixed(2)
    }

    const totalValue = member[totalKey]
    if (hasDisplayValue(totalValue)) {
        return totalKey === 'total_consume_times' ? totalValue : Number(totalValue).toFixed(2)
    }

    return '-'
}

export const getMemberBalanceValue = (member: Pick<IMember, 'balance' | 'bonus' | 'available_balance'>) => {
    if (
        member.available_balance !== undefined &&
        member.available_balance !== null &&
        member.available_balance !== ''
    ) {
        return member.available_balance
    }

    return formatAmountString(toAmountNumber(member.balance) + toAmountNumber(member.bonus))
}

export const canDeleteMember = (member: Pick<IMember, 'source' | 'balance' | 'bonus'>) =>
    member.source === MEMBER_SOURCE_LINGSHOUTONG && Number(member.balance || 0) + Number(member.bonus || 0) <= 0
